<template>
  <BaseFetchData :action="fetchData">
    <template #default="fetchDataProps">
      <BaseCard v-if="fetchDataProps.status.resolved">
        <BaseCardBody clear-padding>
          <div class="flex">
            <div class="w-64 border-r border-gray-200 rounded-l-lg p-4 space-y-8">
              <div v-if="hasFeaturedFunnels" class="space-y-2">
                <h5 class="text-xs text-gray-600 uppercase font-medium">Featured</h5>
                <FeaturedFunnelList v-model="currentFeaturedFunnelId" :funnels="featuredFunnels" />
              </div>
              <div class="space-y-2">
                <h5 class="text-xs text-gray-600 uppercase font-medium">Browse</h5>
                <FunnelCategoryList
                  v-model="currentFunnelCategoryId"
                  :funnel-categories="funnelCategories"
                />
              </div>
            </div>
            <div class="flex-1 rounded-r-lg overflow-hidden">
              <FeaturedFunnel
                v-if="currentFeaturedFunnelId"
                :key="currentFeaturedFunnelId"
                :funnel-id="currentFeaturedFunnelId"
              />
              <template v-else>
                <div v-if="funnelCategoryTitle" class="px-6 py-4 border-b">
                  <h3 class="text-lg font-medium text-center">
                    {{ funnelCategoryTitle }}
                  </h3>
                </div>
                <FunnelList
                  :key="currentFunnelCategoryId"
                  :account-id="accountId"
                  :funnel-category-id="currentFunnelCategoryId"
                />
              </template>
            </div>
          </div>
        </BaseCardBody>
      </BaseCard>
    </template>
  </BaseFetchData>
</template>

<script>
import { accountFunnelCategoriesClient, accountFunnelsClient } from '@/api/clients';
import FunnelCategoryList from './FunnelCategoryList.vue';
import FunnelList from './FunnelList.vue';
import FeaturedFunnelList from './FeaturedFunnelList.vue';
import FeaturedFunnel from './FeaturedFunnel.vue';

export default {
  components: {
    FunnelCategoryList,
    FunnelList,
    FeaturedFunnelList,
    FeaturedFunnel,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentFunnelCategoryId: '',
      currentFeaturedFunnelId: '',
      funnelCategories: [],
      featuredFunnels: [],
    };
  },
  computed: {
    hasFeaturedFunnels() {
      return this.featuredFunnels.length;
    },
    currentFunnelCategory() {
      if (!this.currentFunnelCategoryId) {
        return null;
      }

      return (
        this.funnelCategories.find(
          (funnelCategory) => funnelCategory.id === this.currentFunnelCategoryId
        ) || null
      );
    },
    funnelCategoryTitle() {
      if (!this.currentFunnelCategoryId) {
        return 'All';
      }

      if (!this.currentFunnelCategory) {
        return '';
      }

      return this.currentFunnelCategory.description || this.currentFunnelCategory.name;
    },
  },
  watch: {
    currentFeaturedFunnelId(newValue) {
      if (newValue) {
        this.currentFunnelCategoryId = null;
      }
    },
    currentFunnelCategoryId(newValue) {
      if (newValue !== null) {
        this.currentFeaturedFunnelId = null;
      }
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      return Promise.all([this.fetchFunnelCategories(), this.fetchFeaturedFunnels()]).then(
        ([funnelCategories, featuredFunnels]) => {
          this.funnelCategories = funnelCategories;
          this.featuredFunnels = featuredFunnels;

          if (featuredFunnels.length) {
            this.currentFeaturedFunnelId = featuredFunnels[0].id;
          }

          return Promise.resolve();
        }
      );
    },
    fetchFunnelCategories() {
      return accountFunnelCategoriesClient
        .list(this.accountId, {
          filter: {
            has_funnels: 1,
          },
        })
        .then((response) => response.data);
    },
    async fetchFeaturedFunnels() {
      return accountFunnelsClient
        .list(this.accountId, {
          filter: {
            featured: true,
          },
        })
        .then((response) => response.data);
    },
  },
};
</script>
